<!-- @format -->

<invoice-provider-modal>

    <style>

        .warning {
            color: #E02040;
            font-size: 1.2rem;
            line-height: 1.4em;
        }

        .text {
            font-size: 1.2rem;
            line-height: 1.7em;
        }

        .memo {
            font-size: 1.2rem;
            line-height: 1.5em;
            margin-top: 2rem;
        }

        .warning_area {
            margin-bottom: 1.1rem;
        }

    </style>

    <div
            class="modal js-modal"
            is="modal-base"
            is-open="{ props.isOpen }"
            on-before-show="{ onBeforeShow }"
    >
        <div class="modal__bg"></div>
        <div class="modal__content">
            <h3 class="modal_heading margin-spacing-3_bottom">適格請求書発行事業者情報の設定のお願い</h3>

            <div style="margin-bottom: 1rem">
                <div class="warning_area">
                    <p class="warning">
                        こちらの画面は<br/>
                        <strong>「適格請求書発行事業者の情報を設定していない方」</strong>または
                        <strong>「最後の設定からしばらくお時間が経過した方」</strong><br/>に表示しております。
                    </p>
                </div>

                <p class="text">
                    ライター様の適格請求書発行事業者情報ついて、確認が必要な状態です。<br/>
                    大変お手数ではございますが、下のボタンから適格請求書発行事業者情報の設定のご確認をお願いいたします。
                </p>
            </div>

            <!--/.modal__content_inner-->

            <div class="wrap_button margin-spacing-4_top">
                <button id="button" class="button button-primary button-primary-mini" type="button" value="登録する"
                        onclick={ () => gotoConfigPage() }>適格請求書発行事業者についての設定画面に移動する
                </button>
            </div><!--/.container_button-->

            <p class="memo">
                ※2023年10月1日以降、<strong>適格請求書発行事業者かどうかの登録がない（不明のまま）場合、プロジェクトを受注するなどの一部の機能が制限されます</strong>ので、ご注意ください。
            </p>

        </div>
        <!--modal__content-->
    </div>
    <!--modal-->


    <script>
        import di from "dependency-injection";
        import base from "../modal-base.riot";

        export default {
            components: {
                "modal-base": base,
            },
            state: {},
            onBeforeMount() {

            },
            gotoConfigPage() {
                di.router.push('/info/invoice-provider');
            },
        };
    </script>
</invoice-provider-modal>